<template>
  <div>
    <v-file-input 
      v-model="file" 
      color="primary accent-4" 
      :label="label"
      hint="" 
      :prepend-icon="icon"
      :show-size="1000" 
      clearable
      truncate-length="100"
      v-on:click:clear="callClear()"
      v-on:change="callChange()">
    </v-file-input>
    <div v-if="show_summary && valid_file!==null && this.file!==null" class="ml-8">
      <v-row dense cols="12">
        <v-col cols="4"><span>State</span></v-col>
        <v-col cols="6">
          <span v-if="valid_file"><v-icon color="green">mdi-check-bold</v-icon></span>
          <span v-else><v-icon color="red">mdi-close</v-icon></span>
        </v-col>
      </v-row>
      <v-row dense cols="12">
        <v-col cols="4"><span>Created</span></v-col>
        <v-col cols="8"><span>{{ this.backup_created }}</span></v-col>
      </v-row>      
      <v-row dense cols="12">
        <v-col cols="4"><span>Type</span></v-col>
        <v-col cols="8"><span>{{ this.backup_type }}</span></v-col>
      </v-row>      
      <v-row dense cols="12">
        <v-col cols="4"><span>Info</span></v-col>
        <v-col cols="8"><span>{{ this.backup_info }}</span></v-col>
      </v-row>           
    </div>
  </div>
  </template>
  
  <script>
    export default {
    props: {
        label: String,
        icon: String,
        show_summary: Boolean,
        hspt: Object,
     },      
    data() {
      return {
        content: this.value,
        file: null,
        remove_base64metadata: true,
        valid_file: null,
        file_selected: null,
        taken: '',
        backup_type: '',
        backup_created: '',
        backup_info: '',
      }
    }, 
    methods:{
      callChange(){
        this.initSummary();
        if(this.file !== null){
          this.readFileToBase64(this.file)
            .then(data => this.checkFile(data))
            .catch(() => {
                this.backup_info = 'Backup file could not be read';
                this.backup_type = 'Undetermined';              
                this.valid_file = false;
                this.$emit('loadObject', null); // error; send null object back to caller
              });
        } else { // file was cleared, clear any saved values
          this.valid_file=null;
          this.$emit('loadObject', null); // send null object back to caller
        }        
      },
      initSummary(){
        this.backup_info = '';
        this.backup_type = '';   
        this.backup_created = '';
      },
      callClear(){
        if(this.file!==null){
          this.file=null;
        }
        this.valid_file=null;
        this.$emit('loadObject', null); // send object back to caller
      },
      getFileExtension(arg) {
        return arg.substring(arg.lastIndexOf('.') + 1, arg.length) || arg;
      },     
      fDate(modified){
        let dateModified = `${('00' + modified.getDate()).slice(-2)}-${('00' + (modified.getMonth() + 1)).slice(-2)}-${modified.getFullYear()}`;
        let timeModified = `${('00' + modified.getHours()).slice(-2)}:${('00' + modified.getMinutes()).slice(-2)}:${('00' + modified.getSeconds()).slice(-2)}`;
        return `${dateModified} ${timeModified}`;        
      },
      bytesToSize(bytes) {
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return '0 Byte';
        let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
      },   
      checkFile(data){

        let obj = null;
        let file_selected = new Object();
        
        file_selected.content = data; // base64 encoded file  
        file_selected.decoded_content = window.atob(data); // string value (atob not deprecated if with window. ?)           
        file_selected.name = this.file.name;
        file_selected.conv_size = this.bytesToSize(this.file.size);
        file_selected.extension = this.getFileExtension(this.file.name);
        file_selected.mimetype = this.file.type;
        file_selected.last_modified = this.fDate(new Date(this.file.lastModified));
        
        this.backup_created = file_selected.last_modified;

        // check if the file contents is in string format (backups can only be read if they are JSON)
        try{          
          obj = JSON.parse(file_selected.decoded_content.toString());
        } catch(err){
          if( file_selected.mimetype.trim().length === 0) {
            this.backup_info = `You cannot pass files of type ${file_selected.extension} as objects`;
            this.backup_type = 'Undetermined';
          } else{
            this.backup_info = `You cannot pass files of type ${file_selected.mimetype} as objects`;
            this.backup_type = 'Undetermined';
          }            
          this.valid_file = false;
          this.$emit('loadObject', null);
          return;
        }

        // check if a backup block can be found. This has to be there for all types of backups
        if (obj !== null && Object.prototype.hasOwnProperty.call(obj, 'backup')){
          file_selected.backup_type = obj.backup;
        } else {
          this.backup_info = 'Backup type block could not be found';
          this.backup_type = 'Undetermined';
          this.valid_file = false;
          this.$emit('loadObject', null);
          return;
        }                  

        this.file_selected = file_selected;
        this.valid_file = true;
        this.backup_info = 'Backup valid';
        this.backup_type = file_selected.backup_type;   
        this.$emit('loadObject', obj); // send object back to caller

      },
      readFileToBase64(element) {
        return new Promise((resolve, reject) => {
            var reader = new FileReader();
            reader.readAsDataURL(element);
            reader.onload = () => {
                let encoded;
                try {
                    if (this.remove_base64metadata == true) {
                        encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
                        if ((encoded.length % 4) > 0) {
                            encoded += '='.repeat(4 - (encoded.length % 4));
                        }
                    } else {
                        encoded = reader.result.toString();
                    }
                    resolve(encoded);
                } catch (error) {
                    reject(error);
                }
            }
        });
      },            
    }
  }
</script>